<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-30 17:16:52
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftTypeMapping\ShiftTypeMapping.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:44:53
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_shiftTypeMapping_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-staff-shift-config')"
    @new="showNewMapping = true"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            if (prop == 'department') curDept = value; //触发岗位更新下拉
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :filter-page-data="filterPageData"
        :totalCount="totalCount"
        overLoading
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.shift="{ item }">
          <div class="d-flex flex-wrap flex-row align-end">
            <template v-for="(shift, index) in item.shift_type">
              <StatusChip
                :key="`shift_types---${index}`"
                icon
                content-class=" mx-1 my-1 "
                v-if="index < 10"
                :show-icon="false"
                :bgColor="'rgba(155, 153, 153, 0.3)'"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(shift.shift_type_name) }}
                </template>
              </StatusChip>
              <span
                class="text--secondary"
                v-if="index == 10"
                :key="`shift_types---${index}`"
                >...+{{ item.shift_type.length - 10 }}</span
              >
            </template>
          </div>
        </template>
        <template v-slot:item.staff="{ item }">
          <div style="max-width: 300px">
            <v-list-item dense two-line class="pa-0">
              <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                <StaffAvatar
                  size="36"
                  :src="item.staff.staff_avatar"
                  :staff_name="item.staff.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="table-title text--primary"
                  >{{ $getCommonLangValue(item.staff.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.staff.staff_code }}</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle class="table-subtitle text--secondary">{{
                  $getCommonLangValue(item.staff.job_post_name)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.staff_uuid"
            :delBtn="hasBtn('delete-admin-staff-shift-config')"
            :viewBtn="hasBtn('view-admin-staff-shift-config')"
            editText="message_essweb_list_components_tools_editBtnTip"
            :editBtn="hasBtn('edit-admin-staff-shift-config')"
            :title="$t('label_essweb_eventPropertyGroup_list_title')"
            @delete="toDelete"
            @view="
              (uuid) => {
                viewProperty = true;
                toEdit(uuid);
              }
            "
            @edit="
              (uuid) => {
                viewProperty = false;
                toEdit(uuid);
              }
            "
          />
        </template>
      </Tabler>
    </template>

    <!-- tools -->
    <template v-slot:tools-main>
      <newShiftTypeMapping
        :show="showNewMapping"
        @close="showNewMapping = false"
        @onNew="onNew"
      />
      <editShiftTypeMapping
        :show="showEditMapping"
        @close="
          showEditMapping = false;
          curUuid = null;
        "
        :view="viewProperty"
        :curUuid="curUuid"
        @onEdit="onEdit"
      />
    </template>
  </ContentLayout>
</template>
<script>
import newShiftTypeMapping from "@/Page/EssAdmin/Shift/ShiftTypeMapping/components/newShiftTypeMapping";
import editShiftTypeMapping from "@/Page/EssAdmin/Shift/ShiftTypeMapping/components/editShiftTypeMapping";
import { mapGetters } from "vuex";
export default {
  name: "ShiftTypeMapping",
  components: { newShiftTypeMapping, editShiftTypeMapping },
  computed: {},
  data() {
    return {
      showNewMapping: false,
      curUuid: null,
      viewProperty: false,
      totalCount: 0,
      showEditMapping: false,
      headers: [
        // {
        //   text: "label_essweb_shiftTypeMapping_list_staffIdLabel",
        //   value: "staff_id",
        //   align: "start",
        //   width: 100,
        //   sortable: false,
        // },
        {
          text: "label_essweb_shiftTypeMapping_list_staffNameLabel",
          value: "staff",
          align: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_title",
          value: "shift",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shiftTypeMapping_list_actionsLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      showSelect: false,
      desserts: [],
      filterPageData: null,
      curDept: [],
      filterObjects: [
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],
          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onNew: function (obj) {
      const that = this;
      this.showNewMapping = false;
      this.$Request({
        method: "POST",
        table: "ess_att_map_staff_shift_type",
        url: "/shift-type-mapping/add-shift-type-mapping-table/",
        data: {
          staffIds: obj.staffIds,
          shiftTypeIds: obj.shiftTypeIds,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftTypeMapping_list_newStaffShiftConfigSuccessLabel"
          ),
          type: "success",
        });
        that.getList();
      });
    },
    toEdit: function (uuid) {
      this.showEditMapping = true;
      this.curUuid = uuid;
    },
    onEdit: function (obj) {
      const that = this;
      this.showEditMapping = false;
      this.$Request({
        method: "POST",
        table: "ess_att_map_staff_shift_type",
        url: "/shift-type-mapping/update-shift-type-mapping-table/",
        data: {
          staff_uuid: obj.selectStaff[0]["uuid"],
          shiftTypeIds: obj.selectType,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftTypeMapping_list_updateStaffShiftConfigSuccessLabel"
          ),
          type: "success",
        });
        that.getList();
      });
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_map_staff_shift_type",
        url: "/shift-type-mapping/delete-shift-type-mapping-table/",
        data: {
          uuids: uuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftTypeMapping_list_deleteStaffShiftConfigSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.staff_uuid !== uuid);
      });
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_map_staff_shift_type",
        url: "/shift-type-mapping/get-shift-type-mapping-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
  },
};
</script>
